/**
 * Version-manifest for the "What's New" toast/modal.
 *
 * Adding a new entry:
 *   1. Bump CURRENT_VERSION to a fresh string (semver-ish is fine).
 *   2. Prepend the entry to `WHATS_NEW_ENTRIES` — newest first.
 *   3. The next time a user logs in, they'll see the modal exactly
 *      once (localStorage key `pfo_whats_new_seen_v1` stores the
 *      last-viewed CURRENT_VERSION).
 *
 * Rationale: users don't have to open changelog docs to know what
 * changed — the app tells them once, then never nags. The "seen"
 * flag is versioned so bumping CURRENT_VERSION re-triggers the
 * modal for everyone (returning users see the new set of highlights).
 */

export const CURRENT_VERSION = "iter-76";
export const LS_SEEN_KEY = "pfo_whats_new_seen_v1";

/**
 * Highlights shown in the modal. Keep to ≤5 bullets per entry —
 * more than that stops feeling like "highlights" and starts feeling
 * like a changelog dump. Deep details belong in /app/memory/CHANGELOG.md.
 *
 * Each bullet gets an emoji-less icon key that maps to a Lucide icon
 * in the modal component. Keep the array sorted with newest first
 * so the modal renders that entry's bullets.
 */
export const WHATS_NEW_ENTRIES = [
  {
    version: "iter-76",
    date: "Feb 18, 2026",
    headline: "Personalised nudges + smarter annual pricing",
    bullets: [
      { icon: "bell", text: "Lifecycle reminders: activation nudge on day 3, dormant check at 14 days, pre-expiry ping 30 days before your trial ends." },
      { icon: "zap", text: "Dashboard pill now shows Pro Annual (save 2 OMR/year) if you're deep into your trial — smarter than a flat monthly pitch." },
      { icon: "sparkles", text: "New 'What's New' surface (this one!) — you'll see fresh iteration highlights at most once per release." },
      { icon: "shield", text: "Test suite hardening — 548 backend tests, zero flakes." },
    ],
  },
  {
    version: "iter-75",
    date: "Feb 18, 2026",
    headline: "Smoother trial conversions + cleaner sidebar",
    bullets: [
      { icon: "zap", text: "New inline upgrade pill on the dashboard for a one-tap path to Pro after you dismiss the trial nudge." },
      { icon: "layers", text: "Fully refactored sidebar — same look, tidier code (status badge split into its own component)." },
      { icon: "shield", text: "Backend test suite now 100% green — safer deploys, fewer surprises." },
      { icon: "bell", text: "Coming soon: retention reminders for trial ends + activity nudges." },
    ],
  },
  {
    version: "iter-74",
    date: "Feb 17, 2026",
    headline: "Native-feel mobile + trial-end nudges",
    bullets: [
      { icon: "smartphone", text: "Mobile bottom nav 'More' sheet now closes with a swipe-down gesture, just like native apps." },
      { icon: "zap", text: "'Days-left in your trial' modal now picks the tightest reminder (7-day, then 3-day, then 1-day)." },
      { icon: "layers", text: "AppLayout refactored into smaller components — faster reloads." },
    ],
  },
];
